export { formatarWhatsapp } from '@crm/contracts';

const moedaFmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const numFmt = new Intl.NumberFormat('pt-BR');

export const moeda = (v: string | number | null | undefined) => (v === null || v === undefined || v === '' ? '—' : moedaFmt.format(Number(v)));
export const num = (v: number | null | undefined) => (v === null || v === undefined ? '—' : numFmt.format(v));

/** 'YYYY-MM-DD' → 'dd/mm/aaaa' sem passar por Date (sem fuso) */
export function data(iso: string | null | undefined): string {
  if (!iso) return '—';
  const [a, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${a}`;
}

export function dataHora(ts: string | Date | null | undefined): string {
  if (!ts) return '—';
  return new Date(ts).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function relativo(ts: string | Date | null | undefined): string {
  if (!ts) return 'nunca';
  const dias = Math.floor((Date.now() - new Date(ts).getTime()) / 86_400_000);
  if (dias <= 0) return 'hoje';
  if (dias === 1) return 'ontem';
  return `há ${dias} dias`;
}

export function diasDesde(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const [a, m, d] = iso.split('-').map(Number);
  const hoje = new Date();
  return Math.floor((Date.UTC(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) - Date.UTC(a!, m! - 1, d!)) / 86_400_000);
}

export const hojeISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
